import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'green-x-main-layout',
  imports: [
    RouterOutlet,

  ],
  template: '<router-outlet/>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainLayoutComponent {
}
